import React, { useMemo } from 'react';
import PageTitle from 'components/common/PageTitle';
import { Col, Row } from 'react-bootstrap';
import NavItemComponent from 'components/common/NavItemComponent';
import Portfolio from 'components/common/Portfolio';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import placeholderImage from 'assets/img/placeholder.png';
import { replaceDashesWithSpaces } from 'helpers/utils';

const Shops = () => {
  const { category: cat } = useParams();
  const category = cat && replaceDashesWithSpaces(cat);

  const title = category;
  const { new_tree } = useSelector(state => state.appsetting);

  const { portfolio, shops } = useMemo(() => {
    const findShops = new_tree?.sub_categories
      ?.find(el => el.name === category)
      .sub_categories.map(el => {
        return {
          ...el,
          title: el.name,
          url: `/Dashboard/${category}/${el.name}`,
          icon: el.image01ISfile ?? placeholderImage
        };
      });

    const portfolio = findShops.find(el => el.name === 'Portfolio');
    const shops = findShops.filter(el => el.name !== 'Portfolio');

    return { portfolio, shops };
  }, [new_tree]);

  return (
    <div>
      <PageTitle title={title} />
      <div className="page-content pt-6 mb-6">
        <Row>
          {shops.map((item, index) => (
            <Col key={index} md="4" className="mb-4">
              <NavItemComponent
                {...item}
                className="mb-4 h-100 custom-header"
              />
            </Col>
          ))}
        </Row>
        {portfolio && (
          <Portfolio
            title={'Portfolio'}
            kind={category}
            data={portfolio?.sub_categories}
            portfolioFilter={null}
          />
        )}
      </div>
    </div>
  );
};

export default Shops;
